import React from 'react';
import { motion } from 'framer-motion';
import { ClockIcon } from './icons';
export function UrgencyScarcity() {
  return <section className="py-24 bg-brand-bg-light border-y border-brand-red/20" data-id="element-318">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-319">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-320">
          <div className="flex items-center justify-center gap-4 mb-12" data-id="element-321">
            <ClockIcon className="w-10 h-10 text-brand-red" data-id="element-322" />
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-heading font-bold text-white text-center" data-id="element-323">
              Espacios Limitados Cada Mes
            </h2>
          </div>

          <div className="bg-brand-bg-dark p-8 sm:p-12 rounded-xl border-l-4 border-brand-red shadow-lg text-center sm:text-left" data-id="element-324">
            <p className="text-xl sm:text-2xl text-white mb-6 leading-relaxed" data-id="element-325">
              <strong className="text-brand-red uppercase tracking-wider mr-2" data-id="element-326">
                Importante:
              </strong>
              Geovanny trabaja con un número limitado de proyectos cada mes para
              garantizar calidad y atención personal.
            </p>

            <p className="text-lg text-gray-400 mb-8" data-id="element-327">
              No somos una empresa que toma 30 proyectos a la vez y manda a
              cualquiera.
            </p>

            <div className="bg-brand-red/10 border border-brand-red/30 p-6 rounded-lg mb-10 text-center" data-id="element-328">
              <p className="text-2xl sm:text-3xl font-heading font-bold text-white m-0" data-id="element-329">
                Cuando el calendario está lleno —{' '}
                <span className="text-brand-red" data-id="element-330">está lleno.</span>
              </p>
            </div>

            <p className="text-xl text-gray-300 text-center mb-10" data-id="element-331">
              Si tienes un proyecto en mente,{' '}
              <strong className="text-brand-gold" data-id="element-332">contacta hoy</strong> para
              reservar tu lugar antes de que la lista se cierre.
            </p>

            <div className="text-center" data-id="element-333">
              <motion.a href="tel:2029132653" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="inline-block bg-brand-red hover:bg-red-700 text-white px-8 py-4 rounded-md font-heading font-bold text-xl uppercase tracking-wide transition-colors shadow-lg shadow-brand-red/20" data-id="element-334">
                Reservar Mi Lugar Ahora
              </motion.a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}